import type {
  FixtureType,
  Unit,
} from '#packages/data-collection/models/audit-water-fixture-form';

export const FixtureTypeLabel: Record<FixtureType, string> = {
  toilet: 'Toilet',
  urinal: 'Urinal',
  faucet_lavatory_public: 'Faucet, lavatory, public',
  faucet_lavatory_residential: 'Faucet, lavatory, residential',
  faucet_kitchen: 'Faucet, kitchen',
  faucet_kitchen_residential: 'Faucet, kitchen, residential',
  showerhead: 'Showerhead',
  showerhead_residential: 'Showerhead, residential',
  pre_rinse_spray_valve: 'Pre-rinse spray valve',
  clothes_washer_residential_compact_front_loading:
    'Clothes washer, residential, compact, front-loading',
  clothes_washer_residential_compact_top_loading:
    'Clothes washer, residential, compact, top-loading',
  clothes_washer_residential_standard_front_loading:
    'Clothes washer, residential, standard, front-loading',
  clothes_washer_residential_standard_top_loading:
    'Clothes washer, residential, standard, top-loading',
  dishwasher_residential_standard: 'Dishwasher, residential, standard',
  dishwasher_residential_compact: 'Dishwasher, residential, compact',
  clothes_washer_commercial_front_loading:
    'Clothes washer, commercial, front-loading',
  clothes_washer_commercial_top_loading:
    'Clothes washer, commercial, top-loading',
  dishwasher_commercial_low_temp_under_counter:
    'Dishwasher, commercial, low temp, under counter',
  dishwasher_commercial_low_temp_stationary_single_tank_door:
    'Dishwasher, commercial, low temp, stationary single tank door',
  dishwasher_commercial_low_temp_single_tank_conveyor:
    'Dishwasher, commercial, low temp, single tank conveyor',
  dishwasher_commercial_low_temp_multi_tank_conveyor:
    'Dishwasher, commercial, low temp, multi tank conveyor',
  dishwasher_commercial_hi_temp_under_counter:
    'Dishwasher, commercial, hi temp, under counter',
  dishwasher_commercial_hi_temp_stationary_single_tank_door:
    'Dishwasher, commercial, hi temp, stationary single tank door',
  dishwasher_commercial_hi_temp_single_tank_conveyor:
    'Dishwasher, commercial, hi temp, single tank conveyor',
  dishwasher_commercial_hi_temp_multi_tank_conveyor:
    'Dishwasher, commercial, hi temp, multi tank conveyor',
  dishwasher_commercial_hi_temp_pot_pan_and_utensil:
    'Dishwasher, commercial, hi temp, pot pan & utensil',
};

export const FixtureTypeDefaultUnit: Record<FixtureType, Unit> = {
  toilet: 'Gpf',
  urinal: 'Gpf',
  faucet_lavatory_public: 'Gpm',
  faucet_lavatory_residential: 'Gpm',
  faucet_kitchen: 'Gpm',
  faucet_kitchen_residential: 'Gpm',
  showerhead: 'Gpm',
  showerhead_residential: 'Gpm',
  pre_rinse_spray_valve: 'Gpm',
  clothes_washer_residential_compact_front_loading: 'G/cycle',
  clothes_washer_residential_compact_top_loading: 'G/cycle',
  clothes_washer_residential_standard_front_loading: 'G/cycle',
  clothes_washer_residential_standard_top_loading: 'G/cycle',
  dishwasher_residential_standard: 'G/cycle',
  dishwasher_residential_compact: 'G/cycle',
  clothes_washer_commercial_front_loading: 'G/cycle',
  clothes_washer_commercial_top_loading: 'G/cycle',
  dishwasher_commercial_low_temp_under_counter: 'G/cycle',
  dishwasher_commercial_low_temp_stationary_single_tank_door: 'G/cycle',
  dishwasher_commercial_low_temp_single_tank_conveyor: 'G/cycle',
  dishwasher_commercial_low_temp_multi_tank_conveyor: 'G/cycle',
  dishwasher_commercial_hi_temp_under_counter: 'G/cycle',
  dishwasher_commercial_hi_temp_stationary_single_tank_door: 'G/cycle',
  dishwasher_commercial_hi_temp_single_tank_conveyor: 'G/cycle',
  dishwasher_commercial_hi_temp_multi_tank_conveyor: 'G/cycle',
  dishwasher_commercial_hi_temp_pot_pan_and_utensil: 'G/cycle',
};

export const UnitOptions: Unit[] = ['Gpf', 'Gpm', 'G/cycle', 'Lpf', 'Gph'];
